module.exports = __webpack_public_path__ + "img/bq.4babffc3.jpg";